import React, { type SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

export const Path = (props: IconProps): React.ReactElement => (
  <svg
    width="626"
    height="272"
    viewBox="0 0 626 272"
    preserveAspectRatio="none"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M625 0V104C625 121.673 610.673 136 593 136H33C15.3269 136 1 150.327 1 168V272"
      strokeWidth="4"
      strokeDasharray="8 8"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
)
